import { ChildrenItemIconFields, ItemIconSettings } from '../../../types/Admin/ItemIconTypes';

type ChildrenIconSource = ItemIconSettings | ChildrenItemIconFields;

export const mapChildrenIconFields = (source: ChildrenIconSource) => {
  if ('childrenIconUrl' in source) {
    const apiSource = source as ChildrenItemIconFields;
    return {
      childrenIconUrl:
        apiSource.childrenIconUrl && apiSource.childrenIconUrl !== ''
          ? apiSource.childrenIconUrl
          : '',
      childrenIconFitMode: apiSource.childrenIconFitMode ?? 'scale',
      childrenIconScale: apiSource.childrenIconScale ?? 100,
      childrenIconPositionX: apiSource.childrenIconPositionX ?? 50,
      childrenIconPositionY: apiSource.childrenIconPositionY ?? 50
    };
  }

  const editorSource = source as ItemIconSettings;
  return {
    childrenIconUrl:
      editorSource.iconUrl && editorSource.iconUrl !== '' ? editorSource.iconUrl : '',
    childrenIconFitMode: editorSource.iconFitMode ?? 'scale',
    childrenIconScale: editorSource.iconScale ?? 100,
    childrenIconPositionX: editorSource.iconPositionX ?? 50,
    childrenIconPositionY: editorSource.iconPositionY ?? 50
  };
};
